import React, { useState, useRef, useEffect } from 'react'
import { useStateValue } from '@State'
import { saveAnswer } from '../../api'
import { FeedbackDisplay } from './utils/FeedbackDisplay'
import { TabSplitLayout } from './utils/TabSplitLayout'
import { SaveIndicator } from './utils/SaveIndicator'

export const EssayQuestion = ({ question, renderTabs = true }) => {
  const [state, dispatch] = useStateValue()
  const { coursenum, activitySubmissionId, savingGuids, readonly } = state
  const isSaving = savingGuids.has(question.guid)
  const [localValue, setLocalValue] = useState(question.answer || '')
  const lastSavedRef = useRef(question.answer || '')

  useEffect(() => {
    const selected = (question.answer || '').trim() ? 1 : 0
    const { minSelections, maxSelections } = question.data
    dispatch({
      type: 'SET_FULLY_ANSWERED', guid: question.guid,
      value: selected >= minSelections && selected <= maxSelections
    })
  }, [question.answer])

  const handleSave = async () => {
    if (readonly || isSaving) return
    if (localValue === lastSavedRef.current) return

    dispatch({ type: 'SET_ANSWER', guid: question.guid, answer: localValue })
    dispatch({ type: 'SAVE_START', guid: question.guid })

    try {
      const response = await saveAnswer(coursenum, activitySubmissionId, question.guid, localValue)
      dispatch({ type: 'SAVE_SUCCESS', guid: question.guid, payload: response.data })
      lastSavedRef.current = localValue
    } catch (e) {
      dispatch({ type: 'SAVE_ERROR', guid: question.guid })
    }
  }

  return (
    <>
      <FeedbackDisplay question={question} />
      <div className='position-relative'>
        <SaveIndicator questionGuid={question.guid} />
      </div>
      <TabSplitLayout question={question} renderTabs={renderTabs}>
      <div className="d-flex flex-column align-items-start">
        <div
          role="heading"
          aria-level={3}
          className="mb-2 text-left"
          dangerouslySetInnerHTML={{ __html: question.text }}
        />

        {readonly ? (
          <div
            className="border rounded p-2 w-100 bg-light"
            dangerouslySetInnerHTML={{ __html: question.answer || '' }}
          />
        ) : (
          <textarea
            className="form-control w-100"
            style={{ height: question.data.essaySize + 'px', resize: 'vertical' }}
            value={localValue}
            onChange={e => setLocalValue(e.target.value)}
            onBlur={handleSave}
            disabled={isSaving}
          />
        )}
      </div>
      </TabSplitLayout>
    </>
  )
}
